import React, {useEffect, useRef, useState} from 'react';
import {FaTimes} from "react-icons/fa";
import projectUtils from "../../../../../../utils/project-utils.js";
import Button from "../../../../../../components/button/button.jsx";
import ModalImage from "../../../../../../components/modal/modal-image.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const RouteImage = ({state, setState, isDisabled = false}) => {
    const imgRef = useRef();
    const triggerInput = () => imgRef.current?.click();
    const [imageModal, setImageModal] = useState({open: false, imgScr: null});

    const attachUserImage = ({target: {files}}) => {
        const file = files[0];

        if (file.size >= 2000000) {
            let message = 'Tamanho máximo de arquivo excedido. Limite: 2MB.';
            projectUtils.swalErrorMessage('', message, 'Ok');
            return;
        }

        const previewUrl = URL.createObjectURL(file);
        setState(prev => ({...prev, attach: file, imgPreview: previewUrl}));
    }

    const removeFile = (event) => {
        event.stopPropagation();
        setState(prev => ({...prev, procedureImageid: "", attach: null, imgPreview: null}));
    }

    const openModal = ({target}) => {
        if ((!state?.procedureImageid && !state?.imgPreview) || target.classList.contains("btn-danger") || target.classList.contains("fa-close")) return;
        setImageModal({open: true, imgScr: (state?.procedureImageid && !state?.imgPreview) ? `${state?.procedureImageid}` : state?.imgPreview ? state.imgPreview : getAssetPath("img/no-img.png")})
    }

    const setOpenImageModal = (open) => {
        setImageModal(prev => ({...prev, open}))
    }

    return (
      <>
          <section className={"col-span-3"}>
              <div className={"h-[150px]"}>
                  <div
                    onClick={openModal}
                    className={"cursor-pointer bg-no-repeat bg-contain h-full border border-[#e0e0e0] p-1 rounded"}
                    style={{
                        backgroundImage: (state?.procedureImageid && !state?.imgPreview) ? `url(${API_KEEPER}/general/image/${state?.procedureImageid})` : state?.imgPreview ? `url(${state?.imgPreview})` : `url(${getAssetPath("img/no-img.png")})`, backgroundPosition: "50% center"
                    }}                    >
                      {
                        (state?.procedureImageid || state?.imgPreview) &&
                        <Button type="button" className={"remove-image float-right"} target={"danger"} title={"Remover imagem"} onClick={removeFile} disabled={isDisabled}>
                            <FaTimes />
                        </Button>
                      }
                  </div>
              </div>
              <input type="file" accept="image/png, image/jpeg" className="hidden" name="image" onChange={attachUserImage} ref={imgRef}/>
              <Button type="button" className={"w-full"} target={"primary"} onClick={triggerInput} disabled={isDisabled}>
                  Selecionar procedimento
              </Button>
              <small>* Tamanho máximo 2MB</small>
          </section>

          <ModalImage
            open={imageModal.open}
            setOpen={setOpenImageModal}
            imgUrl={imageModal.imgScr}
          />
      </>
    );
};

export default RouteImage;